<template>
  <svg
    preserveAspectRatio="none"
    width="100%"
    height="100%"
    overflow="visible"
    style="display: block"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="&#228;&#187;&#152;&#230;&#172;&#190; (6) 2">
      <path
        id="Subtract"
        d="M28.1807 4.84473C28.5326 4.84473 28.7966 4.9334 29.0605 5.19727L41.5225 16.5488H47.9795C48.6834 16.5488 49.2997 17.1643 49.2998 17.8682V26.1396H46.6602V19.1885H24.9648L26.5967 20.4199C26.6846 20.4199 26.6855 20.5087 26.7734 20.5088C27.3895 21.1251 28.5333 22.7971 28.4453 24.6445C28.4452 25.9643 27.8284 27.1961 26.6846 28.252C25.6287 29.1317 24.3969 29.6602 23.0771 29.6602C21.5813 29.6601 19.9969 28.9556 18.4131 27.6357L8.46973 19.8262V34.0596H38.3887V36.6992H8.46973V42.1553H25.9814V44.7949H7.15039C6.44646 44.7949 5.83008 44.1785 5.83008 43.4746V17.8682C5.83008 17.8311 5.83162 17.7943 5.83496 17.7578L2.83789 15.4043C2.22238 14.9642 2.13441 14.0845 2.66211 13.5566C3.10204 12.9407 3.98177 12.8531 4.50977 13.3809L20.085 25.7002C22.9879 28.1633 24.4843 26.7569 24.9248 26.3164C25.5408 25.7884 25.8047 25.1716 25.8047 24.5557C25.8045 23.5879 25.1888 22.7083 24.9248 22.4443L15.6855 15.4922C15.0699 15.0522 14.982 14.2604 15.4219 13.6445C15.8619 13.0288 16.6536 12.941 17.2695 13.3809L21.7158 16.7363C21.9119 16.6181 22.1374 16.5489 22.373 16.5488H37.5605L27.6533 7.48535H1.34277C0.638846 7.4853 0.0224609 6.86897 0.0224609 6.16504C0.0224692 5.46111 0.63885 4.84478 1.34277 4.84473H28.1807Z"
        fill="var(--fill-0, white)"
      />
      <path
        id="Subtract_2"
        d="M40.1629 29.325C46.1481 29.3252 50.9998 34.1776 50.9998 40.1629C50.9996 46.148 46.148 50.9996 40.1629 50.9998C34.1776 50.9998 29.3252 46.1481 29.325 40.1629C29.325 34.1775 34.1775 29.325 40.1629 29.325ZM38.2195 32.9373C38.1123 32.9374 38.0071 32.9703 37.9188 33.0311C37.8305 33.0918 37.7626 33.1782 37.7244 33.2781L34.8992 40.6775C34.7671 41.0234 35.0232 41.3942 35.3943 41.3943H38.2381L36.825 46.7215C36.6821 47.2611 37.3661 47.6246 37.7352 47.2049L45.3279 38.5721C45.6283 38.2306 45.3857 37.6944 44.9305 37.6941H41.8328L43.4783 33.6658C43.6203 33.3183 43.364 32.9376 42.9881 32.9373H38.2195Z"
        fill="var(--fill-0, white)"
      />
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'PayToOrder',
} as DefineComponent
</script>
